import { gql } from "@apollo/client";

export const GET_DEDUCTION_STAGES_LOOKUP = gql`
  query DeductionStagesLookup {
    masterDataDeductionStagesLookup {
      count
      items {
        id
        parentId
        stageKey
        stageName
        styles
      }
    }
  }
`;
